var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { PERSONAL_ROBBERY_CONCERNED_PERSON_CHOICES } from '@shared/constants/robberyConstants';
import { PERSONAL_ROBBERY_CONCERNED_PERSON_ANSWER_TRAD_KEYS } from '@declaration/constants/robberyConstants';
const claim = namespace('claim');
const qualification = namespace('qualification');
let PersonalRobberyConcernedPersonQuestion = class PersonalRobberyConcernedPersonQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.choices = PERSONAL_ROBBERY_CONCERNED_PERSON_CHOICES;
    }
    updateClaim(personalRobberyConcernedPerson) {
        this.updateAndSaveQualification({
            qualificationPayload: { personalRobberyConcernedPerson },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.robbery.personal_robbery.concerned_person.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.robbery.personal_robbery.concerned_person.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (this.qualification.personalRobberyConcernedPerson === null) {
            return null;
        }
        return this.$tc(PERSONAL_ROBBERY_CONCERNED_PERSON_ANSWER_TRAD_KEYS[this.qualification.personalRobberyConcernedPerson]);
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], PersonalRobberyConcernedPersonQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], PersonalRobberyConcernedPersonQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], PersonalRobberyConcernedPersonQuestion.prototype, "updateAndSaveQualification", void 0);
PersonalRobberyConcernedPersonQuestion = __decorate([
    Component({
        components: { QuestionPanel, RadioPrimaryButton },
        props: QuestionProps,
    })
], PersonalRobberyConcernedPersonQuestion);
export default PersonalRobberyConcernedPersonQuestion;
